import React, { useState, useEffect } from 'react';
import { FaSpinner, FaCheckCircle, FaExclamationCircle, FaSync } from 'react-icons/fa';
import { getPost, renderPost } from '../../helpers/socialContentService';

const statusConfig = {
    draft: {
        icon: FaSpinner,
        text: 'Pendiente',
        color: 'text-gray-500'
    },
    rendering: {
        icon: FaSpinner,
        text: 'Renderizando',
        color: 'text-blue-500'
    },
    rendered: {
        icon: FaCheckCircle,
        text: 'Completado',
        color: 'text-green-500'
    },
    failed: {
        icon: FaExclamationCircle,
        text: 'Error',
        color: 'text-red-500'
    }
};

const RenderStatus = ({ postId, onComplete, onError }) => {
    const [status, setStatus] = useState('draft');
    const [error, setError] = useState(null);

    const checkStatus = async () => {
        try {
            const post = await getPost(postId);
            setStatus(post.status);

            if (post.status === 'rendered' && onComplete) {
                onComplete(post);
            } else if (post.status === 'failed' && onError) {
                onError(post.metadata?.renderError || 'Error en el renderizado');
            }
        } catch (err) {
            setError(err.message);
            if (onError) onError(err.message);
        }
    };

    useEffect(() => {
        const interval = setInterval(checkStatus, 1000);
        return () => clearInterval(interval);
    }, [postId]);

    const handleRetry = async () => {
        try {
            setError(null);
            setStatus('rendering');
            await renderPost(postId);
        } catch (err) {
            setError(err.message);
            if (onError) onError(err.message);
        }
    };

    const StatusIcon = statusConfig[status]?.icon || FaSpinner;

    return (
        <div className="flex flex-col items-center space-y-4 p-4">
            <div className={`flex items-center space-x-2 ${statusConfig[status]?.color}`}>
                <StatusIcon className={status === 'rendering' ? 'animate-spin' : ''} />
                <span>{statusConfig[status]?.text}</span>
            </div>

            {error && (
                <div className="text-red-500 text-sm text-center">
                    {error}
                </div>
            )}

            {(status === 'failed' || error) && (
                <button
                    onClick={handleRetry}
                    className="flex items-center space-x-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                >
                    <FaSync />
                    <span>Reintentar</span>
                </button>
            )}
        </div>
    );
};

export default RenderStatus; 